<template>
  <div class="module-pupAechive">
    <div class="main">
      <div class="aechive">
        <div class="waterfall-box">
          <!-- 第一列：从上往下 -->
          <div class="col col-1">
            <div
              class="scroll-wrap"
              ref="scrollWrap1"
              :style="animDown"
              @click="togglePlay"
            >
              <div class="list" v-for="(item, i) in column1List" :key="`c1-${i}`">
                <img 
                  :src="item.indexPicUrl" 
                  alt="" 
                  loading="lazy" 
                  width="300" 
                  height="200"
                  @load="onImageLoad(item)"
                  :class="{ 'loading': !item.loaded }"
                />
              </div>
              <div class="list" v-for="(item, i) in column1List" :key="`cp-c1-${i}`">
                <img 
                  :src="item.indexPicUrl" 
                  alt="" 
                  loading="lazy" 
                  width="300" 
                  height="200"
                  @load="onImageLoad(item)"
                  :class="{ 'loading': !item.loaded }"
                />
              </div>
            </div>
          </div>

          <!-- 第二列：从下往上 -->
          <div class="col col-2">
            <div
              class="scroll-wrap"
              :style="animUp"
              @click="togglePlay"
            >
              <div class="list" v-for="(item, i) in column2List" :key="`c2-${i}`">
                <img 
                  :src="item.indexPicUrl" 
                  alt="" 
                  loading="lazy" 
                  width="300" 
                  height="200"
                  @load="onImageLoad(item)"
                  :class="{ 'loading': !item.loaded }"
                />
              </div>
              <div class="list" v-for="(item, i) in column2List" :key="`cp-c2-${i}`">
                <img 
                  :src="item.indexPicUrl" 
                  alt="" 
                  loading="lazy" 
                  width="300" 
                  height="200"
                  @load="onImageLoad(item)"
                  :class="{ 'loading': !item.loaded }"
                />
              </div>
            </div>
          </div>

          <!-- 第三列：从上往下 -->
          <div class="col col-3">
            <div
              class="scroll-wrap"
              :style="animDown"
              @click="togglePlay"
            >
              <div class="list" v-for="(item, i) in column3List" :key="`c3-${i}`">
                <img 
                  :src="item.indexPicUrl" 
                  alt="" 
                  loading="lazy" 
                  width="300" 
                  height="200"
                  @load="onImageLoad(item)"
                  :class="{ 'loading': !item.loaded }"
                />
              </div>
              <div class="list" v-for="(item, i) in column3List" :key="`cp-c3-${i}`">
                <img 
                  :src="item.indexPicUrl" 
                  alt="" 
                  loading="lazy" 
                  width="300" 
                  height="200"
                  @load="onImageLoad(item)"
                  :class="{ 'loading': !item.loaded }"
                />
              </div>
            </div>
          </div>

          <!-- 第四列：从下往上 -->
          <div class="col col-4">
            <div
              class="scroll-wrap"
              :style="animUp"
              @click="togglePlay"
            >
              <div class="list" v-for="(item, i) in column4List" :key="`c4-${i}`">
                <img 
                  :src="item.indexPicUrl" 
                  alt="" 
                  loading="lazy" 
                  width="300" 
                  height="200"
                  @load="onImageLoad(item)"
                  :class="{ 'loading': !item.loaded }"
                />
              </div>
              <div class="list" v-for="(item, i) in column4List" :key="`cp-c4-${i}`">
                <img 
                  :src="item.indexPicUrl" 
                  alt="" 
                  loading="lazy" 
                  width="300" 
                  height="200"
                  @load="onImageLoad(item)"
                  :class="{ 'loading': !item.loaded }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      allData: [],
      column1List: [],
      column2List: [],
      column3List: [],
      column4List: [],
      speed: 40,
      isPlay: true,

      // 分页配置
      current: 1,
      pageSize: 20,
      loading: false,
      hasMore: true,

      // 滚动监听
      checkTimer: null,
      lastProgress: 0,

      // 占位符图片
      placeholderSrc: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZmZmIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxOCIgZmlsbD0iIzY2NiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPuWbvueJqDwvdGV4dD48L3N2Zz4='
    };
  },
  mounted() {
    this.getPageData();
    this.watchScrollEnd();
  },
  beforeDestroy() {
    clearInterval(this.checkTimer);
  },
  methods: {
    // 切换播放暂停
    togglePlay() {
      this.isPlay = !this.isPlay;
    },

    // 图片加载完成回调
    onImageLoad(item) {
      item.loaded = true;
    },

    // 接口请求分页数据
    async getPageData() {
      if (this.loading || !this.hasMore) return;
      this.loading = true;

      const reqTime = Math.floor(new Date().getTime() / 1000);
      try {
        const res = await this.$axios({
          method: "post",
          url: "https://api-register.ujoygames.com/flower/feed_imgs", // 接口
          data: {
            signature: this.common.makeSignature({}, reqTime),
            reqTime,
            current: this.current,
            pageSize: this.pageSize
          }
        });
        if (res.data.code === 0) {
          let list = res.data.data.data || [];
          // 为每个图片项添加 loaded 属性
          list = list.map(item => ({ ...item, loaded: false }));
          
          if (list.length < this.pageSize) {
            this.hasMore = false;
          }
          this.allData.push(...list);
          this.splitCol();
          this.current++;
        }
      } catch (err) {
        console.error("数据请求失败：", err);
      } finally {
        this.loading = false;
      }
    },

    // 数据均分四列
    splitCol() {
      this.column1List = this.allData.filter((_, idx) => idx % 4 === 0);
      this.column2List = this.allData.filter((_, idx) => idx % 4 === 1);
      this.column3List = this.allData.filter((_, idx) => idx % 4 === 2);
      this.column4List = this.allData.filter((_, idx) => idx % 4 === 3);
    },

    // 核心：监听滚动，一轮播完再加载下一页
    watchScrollEnd() {
      this.checkTimer = setInterval(() => {
        if (!this.isPlay || this.loading || !this.hasMore) return;

        const wrap = this.$refs.scrollWrap1;
        if (!wrap) return;

        const style = getComputedStyle(wrap);
        const transform = style.transform;
        let progress = 0;

        if (transform !== "none") {
          const matrix = new DOMMatrix(transform);
          const translateY = matrix.m42;
          const height = wrap.offsetHeight / 2;
          progress = Math.abs(translateY) / height;
        }

        if (progress >= 1 && this.lastProgress < 1) {
          this.getPageData();
        }
        this.lastProgress = progress;
      }, 200);
    }
  },
  computed: {
    // 向下滚动动画
    animDown() {
      const state = this.isPlay ? "running" : "paused";
      return `animation: scrollDown ${this.speed}s linear infinite;animation-play-state: ${state}`;
    },
    // 向上滚动动画
    animUp() {
      const state = this.isPlay ? "running" : "paused";
      return `animation: scrollUp ${this.speed}s linear infinite;animation-play-state: ${state}`;
    }
  }
};
</script>

<style lang="scss">
.module-pupAechive {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .main {
    width: 1343px;
    height: 900px;
    background: url("../../assets/img/pop-up-box/p_archive.png") 50% no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    display: flex;
    align-items: end;
    justify-content: center;

    .aechive {
      width: 822px;
      height: 580px;
      background: url("../../assets/img/pop-up-box/p_archive_cnt.png") 50%
        no-repeat;
      background-size: 100% 100%;
      margin-bottom: 2.5vw;
      overflow: hidden;
    }

    .waterfall-box {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 98%;
      overflow: hidden;
    }

    .col {
      width: 23%;
      flex-shrink: 0;
      height: 95%;
      overflow: hidden;
      margin-right: 1%;
    }

    .col:last-child {
      margin-right: 0;
    }

    .scroll-wrap {
      width: 100%;
      cursor: pointer;
    }

    .list {
      background: #f5f5f5;
      border-radius: 8px;
      margin-bottom: 8px;
      overflow: hidden;
      img {
        width: 100%;
        height: 200px;
        display: block;
        object-fit: cover;
        transition: opacity 0.3s ease;
      }
      img.loading {
        opacity: 0;
      }
    }

    // 向下滚动动画
    @keyframes scrollDown {
      0% {
        transform: translateY(0);
      }
      100% {
        transform: translateY(-50%);
      }
    }

    // 向上滚动动画
    @keyframes scrollUp {
      0% {
        transform: translateY(-50%);
      }
      100% {
        transform: translateY(0);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/pupAechive.vue